import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31558b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-position-panel" }

import { ElementAlignCommands } from '@/types/edit'
import useCombineElement from '@/hooks/useCombineElement'
import useAlignActiveElement from '@/hooks/useAlignActiveElement'
import useAlignElementToCanvas from '@/hooks/useAlignElementToCanvas'
import useUniformDisplayElement from '@/hooks/useUniformDisplayElement'
import { useI18n } from 'vue-i18n'
import {
  Divider,
  Button,
  Tooltip,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MultiPositionPanel',
  setup(__props) {

const { t, locale } = useI18n();

const ButtonGroup = Button.Group

const { canCombine, combineElements, uncombineElements } = useCombineElement()
const { alignActiveElement } = useAlignActiveElement()
const { alignElementToCanvas } = useAlignElementToCanvas()
const { displayItemCount, uniformHorizontalDisplay, uniformVerticalDisplay } = useUniformDisplayElement()

// 多选元素对齐，需要先判断当前所选中的元素状态：
// 如果所选元素为一组组合元素，则将它对齐到画布；
// 如果所选元素不是组合元素或不止一组元素（即当前为可组合状态），则将这多个（多组）元素相互对齐。
const alignElement = (command: ElementAlignCommands) => {
  if (canCombine.value) alignActiveElement(command)
  else alignElementToCanvas(command)
}

return (_ctx: any,_cache: any) => {
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")!
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")!
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")!
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")!
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")!
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")!
  const _component_IconGroup = _resolveComponent("IconGroup")!
  const _component_IconUngroup = _resolveComponent("IconUngroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ButtonGroup), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.left`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (alignElement(_unref(ElementAlignCommands).LEFT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.horizontalCenter`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (alignElement(_unref(ElementAlignCommands).HORIZONTAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignHorizontally)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.right`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (alignElement(_unref(ElementAlignCommands).RIGHT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonGroup), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.top`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (alignElement(_unref(ElementAlignCommands).TOP)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.verticalCenter`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (alignElement(_unref(ElementAlignCommands).VERTICAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignVertically)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.bottom`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (alignElement(_unref(ElementAlignCommands).BOTTOM)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignBottom)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }),
    (_unref(displayItemCount) > 2)
      ? (_openBlock(), _createBlock(_unref(ButtonGroup), {
          key: 0,
          class: "row"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(uniformHorizontalDisplay)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`public.font.uniformHorizontal`)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              style: {"flex":"1"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(uniformVerticalDisplay)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`public.font.uniformVertical`)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Divider)),
    _createVNode(_unref(ButtonGroup), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          disabled: !_unref(canCombine),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(combineElements)())),
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconGroup, { style: {"margin-right":"3px"} }),
            _createTextVNode(_toDisplayString(_ctx.$t(`public.font.combine`)), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          disabled: _unref(canCombine),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(uncombineElements)())),
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconUngroup, { style: {"margin-right":"3px"} }),
            _createTextVNode(_toDisplayString(_ctx.$t(`public.font.unCombine`)), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})